import { graphql } from '@mews-commander/guest-profile';

export const LoyaltyMembershipBasicFieldsFragment = graphql(`
    fragment LoyaltyMembershipBasicFields on Membership {
        code
        createdUtc
        id
        isPrimary
        state
        updatedUtc
        program {
            ...LoyaltyProgramFields
        }
    }
`);
